

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface IpServiceCategoryReportParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface IpServiceCategoryReport {

  fromDate: any;
  toDate: string;
  ServiceCategoryId: string;
   
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: IpServiceCategoryReportParameter[];
    links?: any;
}

export abstract class IpServiceCategoryReportData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<IpServiceCategoryReport[]>;
  abstract create(url: string,data: IpServiceCategoryReport): Observable<any>;
  abstract update(url: string,data: IpServiceCategoryReport): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchList(url: string, data:any): Observable<any>;
}
